import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

interface IHomePage_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IHomePage_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  TeknikMasaMusteriSayi: any[];
  TeknikMasaMusteriSayi_dummy: any[];
  SisyaKullaniciSayi: any[];
  SisyaKullaniciSayi_dummy: any[];
  DepartmanlarGetir: any[];
  DepartmanlarGetir_dummy: any[];
  GetSisyaKullaniciDetay: any[];
  GetSisyaKullaniciDetay_dummy: any[];
  TicketlerSayi: any[];
  TicketlerSayi_dummy: any[];
  TicketGetirYAZERP: any[];
  TicketGetirYAZERP_dummy: any[];
  NAVIGATE: string;
  NAVIGATE_dummy: string;

  isMasterPageInitLoaded?: boolean;
  isMasterPageRecurringLoaded?: boolean;
  shouldTriggerPageInit?: boolean;
}

export class HomePage_ScreenBase extends React.PureComponent<IHomePage_ScreenProps, any> {
  homepage_14377_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "0140ac25-79e8-4970-bae8-db8c55d4bd78",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: []
    },
    {
      Id: "601f1d98-58f2-429e-9bdb-1f5ef98fb3d7",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 319108, PropertyName: "value", Value: "Ticket Sayısı" },
        { Id: 609610, PropertyName: "value", Value: "Müşteri Sayısı" },
        { Id: 883457, PropertyName: "value", Value: "Kullanıcı Sayısı" },
        { Id: 739431, PropertyName: "value", Value: "📃Güncel İşler  " },
        { Id: 556222, PropertyName: "placeholder", Value: "Arama" },
        { Id: 28985, PropertyName: "title", Value: "Title" },
        { Id: 726688, PropertyName: "value", Value: "[datafield:baslik]" },
        { Id: 301832, PropertyName: "value", Value: "[datafield:musteri]" },
        { Id: 636769, PropertyName: "value", Value: "[datafield:departman]" }
      ]
    }
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.homepage_556222_value_kuikaTextInputRef = React.createRef();
    this.homepage_14377_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      TeknikMasaMusteriSayi: [],
      SisyaKullaniciSayi: [],
      DepartmanlarGetir: [],
      GetSisyaKullaniciDetay: [],
      TicketlerSayi: [],
      TicketGetirYAZERP: [],
      NAVIGATE: "",

      isMasterPageInitLoaded: false,
      isMasterPageRecurringLoaded: false,
      shouldTriggerPageInit: false
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("homepage", "masterekran_screen");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.HomePagePageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("homepage", "masterekran_screen");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("homepage", "masterekran_screen");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.HomePagePageInit();
    }

    if (
      prevState.isMasterPageInitLoaded !== this.state.isMasterPageInitLoaded &&
      this.state.isMasterPageInitLoaded === true
    ) {
      await this.HomePagePageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (key.startsWith("NavVisible") && prevState[key] === true && this.state[key] === false) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: []
        }
      ]);
    }
  };

  setMasterPageInitLoaded = (value: boolean) => {
    this.setState({ isMasterPageInitLoaded: value });
  };

  setMasterPageRecurringLoaded = (value: boolean) => {
    this.setState({ isMasterPageRecurringLoaded: value });
  };
  setShouldTriggerPageInit = (value: boolean) => {
    this.setState({ shouldTriggerPageInit: value });
  };

  HomePagePageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    let localVar = {
      KullaniciAdi_3: ReactSystemFunctions.convertToTypeByName(ReactSystemFunctions.getMyUsername(), "string"),
      admin_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          stateVars.GetSisyaKullaniciDetay !== undefined
            ? stateVars.GetSisyaKullaniciDetay?.length > 0
              ? stateVars.GetSisyaKullaniciDetay[0].isAdmin
              : null
            : this.state.GetSisyaKullaniciDetay?.length > 0
            ? this.state.GetSisyaKullaniciDetay[0].isAdmin
            : null
        ),
        "number"
      ),
      Departman_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetSisyaKullaniciDetay !== undefined
            ? stateVars.GetSisyaKullaniciDetay?.length > 0
              ? stateVars.GetSisyaKullaniciDetay[0].departman
              : null
            : this.state.GetSisyaKullaniciDetay?.length > 0
            ? this.state.GetSisyaKullaniciDetay[0].departman
            : null
        ),
        "string"
      ),
      isAdmin_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSisyaKullaniciDetay !== undefined
            ? stateVars.GetSisyaKullaniciDetay?.length > 0
              ? stateVars.GetSisyaKullaniciDetay[0].isAdmin
              : null
            : this.state.GetSisyaKullaniciDetay?.length > 0
            ? this.state.GetSisyaKullaniciDetay[0].isAdmin
            : null
        ),
        "boolean"
      ),
      Arama_5: ReactSystemFunctions.convertToTypeByName("", "string"),
      Departman_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetSisyaKullaniciDetay !== undefined
            ? stateVars.GetSisyaKullaniciDetay?.length > 0
              ? stateVars.GetSisyaKullaniciDetay[0].departman
              : null
            : this.state.GetSisyaKullaniciDetay?.length > 0
            ? this.state.GetSisyaKullaniciDetay[0].departman
            : null
        ),
        "string"
      )
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "HomePage/HomePagePageInit", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.TeknikMasaMusteriSayi = result?.data.teknikMasaMusteriSayi;
    formVars.homepage_247436_value = ReactSystemFunctions.toString(
      this,
      stateVars.TeknikMasaMusteriSayi !== undefined
        ? stateVars.TeknikMasaMusteriSayi?.length > 0
          ? stateVars.TeknikMasaMusteriSayi[0].teknikMasaMusteriSayi
          : null
        : this.state.TeknikMasaMusteriSayi?.length > 0
        ? this.state.TeknikMasaMusteriSayi[0].teknikMasaMusteriSayi
        : null
    );
    stateVars.SisyaKullaniciSayi = result?.data.sisyaKullaniciSayi;
    formVars.homepage_941478_value = ReactSystemFunctions.toString(
      this,
      stateVars.SisyaKullaniciSayi !== undefined
        ? stateVars.SisyaKullaniciSayi?.length > 0
          ? stateVars.SisyaKullaniciSayi[0].sisyaKullaniciSayi
          : null
        : this.state.SisyaKullaniciSayi?.length > 0
        ? this.state.SisyaKullaniciSayi[0].sisyaKullaniciSayi
        : null
    );
    stateVars.DepartmanlarGetir = result?.data.departmanlarGetir;
    stateVars.GetSisyaKullaniciDetay = result?.data.getSisyaKullaniciDetay;
    stateVars.TicketlerSayi = result?.data.ticketlerSayi;
    formVars.homepage_139109_value = ReactSystemFunctions.toString(
      this,
      stateVars.TicketlerSayi !== undefined
        ? stateVars.TicketlerSayi?.length > 0
          ? stateVars.TicketlerSayi[0].ticketSayi
          : null
        : this.state.TicketlerSayi?.length > 0
        ? this.state.TicketlerSayi[0].ticketSayi
        : null
    );
    stateVars.TicketGetirYAZERP = result?.data.ticketGetirYAZERP;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePagePageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePagePageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    formVars.homepage_139109_value = ReactSystemFunctions.toString(
      this,
      stateVars.TicketlerSayi !== undefined
        ? stateVars.TicketlerSayi?.length > 0
          ? stateVars.TicketlerSayi[0].ticketSayi
          : null
        : this.state.TicketlerSayi?.length > 0
        ? this.state.TicketlerSayi[0].ticketSayi
        : null
    );

    formVars.homepage_247436_value = ReactSystemFunctions.toString(
      this,
      stateVars.TeknikMasaMusteriSayi !== undefined
        ? stateVars.TeknikMasaMusteriSayi?.length > 0
          ? stateVars.TeknikMasaMusteriSayi[0].teknikMasaMusteriSayi
          : null
        : this.state.TeknikMasaMusteriSayi?.length > 0
        ? this.state.TeknikMasaMusteriSayi[0].teknikMasaMusteriSayi
        : null
    );

    formVars.homepage_941478_value = ReactSystemFunctions.toString(
      this,
      stateVars.SisyaKullaniciSayi !== undefined
        ? stateVars.SisyaKullaniciSayi?.length > 0
          ? stateVars.SisyaKullaniciSayi[0].sisyaKullaniciSayi
          : null
        : this.state.SisyaKullaniciSayi?.length > 0
        ? this.state.SisyaKullaniciSayi[0].sisyaKullaniciSayi
        : null
    );

    stateVars.dataSource_14377 = this.state.TicketGetirYAZERP;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  HomePageComponent_623080_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "TicketListesi",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_637945_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "MusteriListesi",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_765766_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "KullaniciListesi",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_198072_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "TicketListesi",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_556222_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      isAdmin_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSisyaKullaniciDetay !== undefined
            ? stateVars.GetSisyaKullaniciDetay?.length > 0
              ? stateVars.GetSisyaKullaniciDetay[0].isAdmin
              : null
            : this.state.GetSisyaKullaniciDetay?.length > 0
            ? this.state.GetSisyaKullaniciDetay[0].isAdmin
            : null
        ),
        "boolean"
      ),
      Arama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(this, "homepage_556222_value", "value", "", "", "")
        ),
        "string"
      ),
      Departman_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetSisyaKullaniciDetay !== undefined
            ? stateVars.GetSisyaKullaniciDetay?.length > 0
              ? stateVars.GetSisyaKullaniciDetay[0].departman
              : null
            : this.state.GetSisyaKullaniciDetay?.length > 0
            ? this.state.GetSisyaKullaniciDetay[0].departman
            : null
        ),
        "string"
      )
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "HomePage/HomePageComponent_556222_onChange", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.TicketGetirYAZERP = result?.data.ticketGetirYAZERP;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePageComponent_556222_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePageComponent_556222_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    stateVars.dataSource_14377 = this.state.TicketGetirYAZERP;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_529959_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "TicketDetay",
      "TicketID",
      ReactSystemFunctions.convertToTypeByName(ReactSystemFunctions.value(this, "homepage_14377_value", "id"), "number")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "TicketDetay",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "121936",
      null,
      null,
      "true",
      "1600px",
      "70vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, , , 121936] as number[];
    if (
      isFromMaster ||
      ((window.kuika?.disableSmartExecutePageInit?.["HomePage"] ?? false) && pageInitCallerNavDiIDs.indexOf(diId) > -1)
    ) {
      await this.HomePagePageInit();
    } else if (window.kuika?.serverRequestCount > 0 && pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.HomePagePageInit();
    }
  }
}
